export default function ChevronRightIcon() { 
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M8.71967 19.2803C8.42678 18.9874 8.42678 18.5126 8.71967 18.2197L14.4393 12.5L8.71967 6.78033C8.42678 6.48744 8.42678 6.01256 8.71967 5.71967C9.01256 5.42678 9.48744 5.42678 9.78033 5.71967L16.0303 11.9697C16.3232 12.2626 16.3232 12.7374 16.0303 13.0303L9.78033 19.2803C9.48744 19.5732 9.01256 19.5732 8.71967 19.2803Z" fill="white"/>
        </svg>
    );
}